import createAuthRefreshInterceptor from 'axios-auth-refresh'

export default process.env.SERVER
  ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ((createAuthRefreshInterceptor as any)
      .default as typeof createAuthRefreshInterceptor)
  : createAuthRefreshInterceptor
